module.exports = __webpack_public_path__ + "img/JPME_120X35.f451a67d.png";